// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__UZWvK","expandIcon":"AccordionButton_expandIcon__53z53","expanded":"AccordionButton_expanded__2h5O7"};